export const { NODE_ENV } = process.env.dotenv;
import { getEnvMAP } from './constant';
import { getUserInfo } from '@core/rc-components/es/Thing/utils';
const getOrigin = (mode, loginType) => {
    const origins = getOrigins();
    return origins[mode][loginType];
};
export const fetchEnv = (mode, authLoginType) => {
    return new Promise((resolve, reject) => {
        const fetchUrl = '/component-shared-center/env.json';
        fetch(fetchUrl)
            .then((r) => r.json())
            .then((res) => {
            setEnvToWindow(res);
            resolve(res);
        })
            .catch((e) => {
            reject(e);
        });
    });
};
export const setEnvToWindow = (res) => {
    Object.entries(res).forEach(([a, b]) => {
        window[a] = b;
    });
};
/**
 * 在没有登录情况下需要传入 mode,authLoginType
 * @param key
 * @param mode
 * @param authLoginType
 * @returns
 */
export const getEnvKey = async (key, mode, authLoginType) => {
    if (window[key]) {
        return Promise.resolve(window[key]);
    }
    const res = (await fetchEnv(mode, authLoginType));
    return Promise.resolve(res[key]);
};
export const getApiUrl = (authLoginType) => {
    if (NODE_ENV === 'production') {
        return '';
    }
    else {
        if (getUserInfo()?.id) {
            return '';
        }
        const _authLoginType = authLoginType || sessionStorage.getItem('authLoginType') || 'KXGC';
        return process.env.dotenv[`API_URL_${_authLoginType}`];
    }
};
export const getAse = () => {
    if (NODE_ENV === 'production') {
        return 'ta(CMmC8o^9RjEwT';
    }
    else {
        return process.env.dotenv['KEY_OF_ASE'];
    }
};
export const getBMapKey = () => {
    if (NODE_ENV === 'production') {
        return window['BAIDU_MAP_KEY'];
    }
    else {
        return process.env.dotenv['BAIDU_MAP_KEY'];
    }
};
export const getOrigins = () => {
    const ENV_MAP = getEnvMAP();
    const systensNames = Object.keys(ENV_MAP);
    const { devMap, testMap } = systensNames.reduce((a, key) => {
        a.devMap = {
            ...a.devMap,
            [key]: ENV_MAP[key].devUrl,
        };
        a.testMap = {
            ...a.testMap,
            [key]: ENV_MAP[key].testUrl,
        };
        return a;
    }, {
        devMap: {},
        testMap: {},
    });
    return {
        dev: devMap,
        test: testMap,
    };
};
// export const origins = {
//   dev: devMap,
//     test: testMap,
//   // {
//   //   // [ENV.KXGC]: 'http://ymsl.kxgcc.com:30872',
//   //   // [ENV.LABOR]: 'http://ymsl-yj.kxgcc.com:30872',
//   //   // [ENV.OSS]: 'http://dev-oss.kxgcc.com:30872',
//   //   // [ENV.GOV]: 'http://dev-gov.kxgcc.com:32238',
//   //   // [ENV.SCM]: 'http://dev-scm.kxgcc.com:30872',
//   //   // [ENV.PSI]: 'http://dev-psi.kxgcc.com:30872',
//   //   // [ENV.GROUP]: 'http://dev-group.kxgcc.com:30872',
//   // }
//   test: testMap,
//   //  {
//   //   [ENV.KXGC]: 'https://test-ymsl.kxgcc.com:30195',
//   //   [ENV.LABOR]: 'https://test-yj.kxgcc.com:30195',
//   //   [ENV.OSS]: 'https://test-oss.kxgcc.com:30195',
//   //   [ENV.GOV]: 'https://test-gov.kxgcc.com:30195',
//   //   [ENV.SCM]: 'https://test-scm.kxgcc.com:30195',
//   //   [ENV.PSI]: 'https://test-psi.kxgcc.com:30195',
//   //   [ENV.GROUP]: 'https://test-group.kxgcc.com:30195',
//   // },
// };
